import { appliedReportActionTypes } from './applied';
import { currentReportActionTypes } from './current';

export default {
    ...currentReportActionTypes,
    ...appliedReportActionTypes,
};
